import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/localStorage.service';
import { RNDataTransferService } from '../../services/rn-data-transfer.service';
import {
  EASYEAT_PARTNER_ANDROID_STORE_URL,
  EASYEAT_PARTNER_IOS_STORE_URL,
  REQUIRED_APP_VERSION,
  isIosDevice,
} from './app-update-notice.config';

declare function send_data(params: string): any;

@Component({
  selector: 'app-app-update-notice',
  templateUrl: './app-update-notice.component.html',
  styleUrls: [
    '../downtime-warning/downtime-warning.component.css',
    './app-update-notice.component.css',
  ],
})
export class AppUpdateNoticeComponent implements OnInit {
  readonly requiredVersion = REQUIRED_APP_VERSION;
  isReactNativeApp = false;
  private pendingLoginPath = '/login';

  constructor(
    private dialogRef: MatDialogRef<AppUpdateNoticeComponent>,
    private router: Router,
    private localStorage: LocalStorageService,
    private rnDataTransferService: RNDataTransferService
  ) {}

  ngOnInit(): void {
    this.isReactNativeApp = this.detectReactNativeApp();
  }

  skip(): void {
    this.dialogRef.close('skip');
  }

  proceedToStore(): void {
    this.logoutCurrentSession();
    this.redirectToStore();
    this.sendNativeLogout();
    this.dialogRef.close('proceed');
    this.navigateToLogin();
  }

  private detectReactNativeApp(): boolean {
    return (
      this.rnDataTransferService.isReactNativeApp() ||
      !!(window as any).ReactNativeWebView
    );
  }

  private logoutCurrentSession(): void {
    const userType = localStorage.getItem('ee_user_type');
    this.clearSessionStorage();

    this.pendingLoginPath =
      userType === 'rest_hq_admin' || userType === 'rest_hq_staff'
        ? '/hq/login'
        : '/login';
  }

  private clearSessionStorage(): void {
    this.localStorage.remove('token');
    this.localStorage.remove('hideSidenav');
    this.localStorage.remove('restaurant_details');
    this.localStorage.remove('restaurant_id');
    this.localStorage.remove('restaurant_phone');
    this.localStorage.remove('staff_user_id');
    this.localStorage.remove('restaurant_settings');
    this.localStorage.remove('restaurant_api_version');
    this.localStorage.remove('hq_settings');
    this.localStorage.remove('hq_logo');
    this.localStorage.remove('eeTotalEarnings');
    this.localStorage.remove('analyticsData');
    this.localStorage.remove('lastExecutionDate');
    this.localStorage.remove('roles');
    this.localStorage.remove('blockFeatureList');
    this.localStorage.remove('blockedDuesPending');
    this.localStorage.remove('fc_rest_ids');
    this.localStorage.remove('fc_court_view');
    this.localStorage.remove('saas_company_id');
    this.localStorage.remove('lhdn_first_time');
    localStorage.removeItem('user_type');
    localStorage.removeItem('restaurant_name');
    localStorage.removeItem('user_name');
    localStorage.removeItem('restaurant_address');
    localStorage.removeItem('restaurant_location');
    localStorage.removeItem('restaurant_type');
    localStorage.removeItem('ee_theme');
    localStorage.removeItem('ee_user_type');
    localStorage.removeItem('ee_fpMapping_later');
  }

  private redirectToStore(): void {
    if (this.isReactNativeApp) {
      this.rnDataTransferService.sendRNForRedirectToStore(
        EASYEAT_PARTNER_ANDROID_STORE_URL,
        EASYEAT_PARTNER_IOS_STORE_URL
      );
      return;
    }

    const storeUrl = isIosDevice()
      ? EASYEAT_PARTNER_IOS_STORE_URL
      : EASYEAT_PARTNER_ANDROID_STORE_URL;
    window.open(storeUrl, '_blank', 'noopener,noreferrer');
  }

  private sendNativeLogout(): void {
    try {
      send_data(JSON.stringify({ action: 'logout' }));
    } catch (error) {}
  }

  private navigateToLogin(): void {
    this.router.navigateByUrl(this.pendingLoginPath);
  }
}
